import React, { useEffect } from 'react';
import { Award, Target, TrendingUp } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { mockCoaches } from '../mock';
import './CoachesPage.css';

const CoachesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const coachImages = [
    'https://customer-assets.emergentagent.com/job_elite-boxing-camp/artifacts/zpudktds_df.jpeg',
    'https://customer-assets.emergentagent.com/job_elite-boxing-camp/artifacts/34yebolr_q.jpeg'
  ];

  return (
    <div className="coaches-page">
      <Navbar />
      
      <div className="page-hero">
        <h1>MEET OUR COACHES</h1>
        <p>Train with experienced professionals dedicated to your success</p>
      </div>

      <section className="section">
        <div className="coaches-container">
          {mockCoaches.map((coach, index) => (
            <div key={coach.id} className="coach-profile-card">
              <div className="coach-image-section">
                <img 
                  src={coachImages[index]} 
                  alt={coach.name}
                  className="coach-image"
                />
                <div className="coach-badge">
                  <Award size={24} />
                  <span>{coach.experience}</span>
                </div>
              </div>

              <div className="coach-info-section">
                <h2>{coach.name}</h2>
                <p className="coach-title">{coach.title}</p>
                
                <div className="coach-specialty">
                  <Target size={20} />
                  <span>{coach.specialty}</span>
                </div>

                <p className="coach-bio">{coach.bio}</p>

                <div className="coach-credentials">
                  <h4>Credentials & Achievements</h4>
                  <ul>
                    {coach.credentials.map((credential, idx) => (
                      <li key={idx}>
                        <TrendingUp size={16} />
                        <span>{credential}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section section-dark philosophy-section">
        <div className="philosophy-content">
          <h2>OUR COACHING PHILOSOPHY</h2>
          <p className="philosophy-intro">
            At Team Kent Boxing International Gym, you're not just a client - you're family. Our commitment is to provide a safe, professional environment where your health, fitness, and progress always come first.
          </p>
          <div className="philosophy-grid">
            <div className="philosophy-item">
              <h3>Technical Excellence</h3>
              <p>
                Master the fundamentals before advancing. We build solid foundations that last a lifetime.
              </p>
            </div>
            <div className="philosophy-item">
              <h3>Mental Fortitude</h3>
              <p>
                Boxing is as much mental as physical. We train your mind to stay focused under pressure.
              </p>
            </div>
            <div className="philosophy-item">
              <h3>Personalized Approach</h3>
              <p>
                Every fighter is unique. We tailor our coaching to your specific goals and learning style.
              </p>
            </div>
            <div className="philosophy-item">
              <h3>Continuous Growth</h3>
              <p>
                There's always room to improve. We push you to exceed your limits while staying safe.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CoachesPage;